import actionTypes from '../constants/actionTypes';

const initialState = [];

export default function reportsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.MELDUNG_ADD: {
      const newReport = {
        id: action.report.id,
        title: action.report.title,
        shortDescription: action.report.shortdescription,
        fullDescription: action.report.details,
        location: action.report.location,
        validFrom: action.report.valid_from,
        validUntil: action.report.valid_until,
        category: action.report.category,
        categoryIcon: action.report.categoryIcon,
        area: action.report.area,
        sender: action.report.sender,
        isCatastrophy: action.report.isCatastrophy,
        deleted: false,
        read: action.read,
      };
      return [...state, newReport];
    }
    case actionTypes.MARK_AS_READ: {
      const id = parseInt(action.id, 10);
      return state.map(report => {
        if (report.id !== id) return report;

        return {
          ...report,
          read: true,
        };
      });
    }
    case actionTypes.MELDUNG_REMOVE: {
      const id = parseInt(action.report.id, 10);
      return state.filter(report => report.id !== id);
    }
    case actionTypes.CLEAR_REPORTS: {
      return initialState;
    }
    case actionTypes.MARK_AS_DELETED: {
      const id = parseInt(action.id, 10);
      return state.map(report => {
        if (report.id !== id) return report;

        return {
          ...report,
          deleted: true,
        };
      });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/reportsReducer.js